import { Avatar, FormControlLabel, Grid, IconButton, Switch, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CloseIcon from '@mui/icons-material/Close'

import { AccountConnectionIndicator } from './account-connection-indicator.component'
import { AccountConnectionWrapper } from './account-connection-wrapper.component'

import useStyles from 'src/components/associations/styles'
import { useStyles as useStyles1 } from './styles'

interface IProps {
  icon: string
  text: string
  subText?: string
  handleSelectItem: (value: string) => void
  handleToggleItem: () => void
  id: string
  approvedConnection: boolean | null
  landingShow?: boolean
  isDisabled?: boolean
  aiGenerated?: boolean
}

const ConnectionListItem = ({
  isDisabled,
  landingShow,
  icon,
  subText,
  text,
  handleSelectItem,
  handleToggleItem,
  id,
  approvedConnection,
  aiGenerated = false,
}: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles({})
  const classes1 = useStyles1()

  const handleItemRemove = () => {
    handleSelectItem?.(id)
  }

  const handleChangeSwitch = () => {
    handleToggleItem?.()
  }

  return (
    <>
      <div className={`${classes1.selectionWrapper} ${aiGenerated && classes1.bgAiGenerated}`}>
        <Grid className={`${classes1.selectionContent} ${aiGenerated && classes1.bgAiGenerated}`}>
          <Grid className={classes.selectionItem}>
            <Avatar alt={text} src={icon} className={`${classes.image}`} />
            <Grid>
              <Typography className={`${classes.selectionText} ${classes.selectionTextDark}`}>
                <strong>{text}</strong>
              </Typography>
              <Typography className={`${classes.selectionSubtext} ${classes.selectionTextDark}`}>
                {subText}
              </Typography>
            </Grid>
          </Grid>
          <div className={classes1.statusWrapper}>
            <AccountConnectionWrapper approvedConnection={approvedConnection}>
              <AccountConnectionIndicator approvedConnection={approvedConnection} />
            </AccountConnectionWrapper>
            {!isDisabled && (
              <IconButton onClick={handleItemRemove} size="small">
                <CloseIcon />
              </IconButton>
            )}
          </div>
        </Grid>
        {!isDisabled && (
          <div className={classes1.switchWrapper}>
            <FormControlLabel
              sx={{ ml: 0, mr: 0 }}
              checked={landingShow}
              onChange={handleChangeSwitch}
              control={<Switch size="small" />}
              label={t('show-on-journey-landing-label.v')}
              labelPlacement="start"
              classes={{
                label: classes.selectionSubtext,
              }}
            />
          </div>
        )}
      </div>
    </>
  )
}

export { ConnectionListItem }
